







































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
//import { Route } from "vue-router";
//import MainMenu from "@/views/MainMenu.vue"

@Component
export default class Kraal extends Vue {
  get currentPageIndex() {
    let currentPagePath = this.$route.path.slice("/kraal/".length);
    return this.pages.findIndex(path => currentPagePath == path);
  }

  get currentPageName() {
    let currentPage = this.pages[this.currentPageIndex];
    switch (currentPage) {
      case "kraal-info":
        return "Info";
      case "morbidities":
        return "Morbidities";
      case "morbidities-graph":
        return "Morbidities";
      case "mortalities":
        return "Mortalities";
      case "mortalities-graph":
        return "Mortalities";
      case "feeding":
        return "Feeding";
      case "feeding-graph":
        return "Feeding";
      case "animals-in-kraal":
        return "Animals";
      default:
        return "";
    }
  }

  touch = {
    left: () => this.goToNextPage(),
    right: () => this.goToPreviousPage(),
    up: () => {},
    down: () => {}
  }

  transitionName: string = "";

  pages = [
    "kraal-info",
    "morbidities",
    "morbidities-graph",
    "mortalities",
    "mortalities-graph",
    "feeding",
    "feeding-graph",
    "animals-in-kraal"
  ];

  onNextClick() {
    this.goToNextPage();
  }

  onPreviousClick() {
    this.goToPreviousPage();
  }

  goToNextPage() {
    let nextPageIndex = (this.currentPageIndex + 1) % this.pages.length;
    //this.transitionName = "next";
    this.$router.push({ path: this.pages[nextPageIndex] });
  }

  goToPreviousPage() {
    let previousPageIndex =
      this.currentPageIndex - 1 < 0
        ? this.pages.length - 1
        : this.currentPageIndex - 1;
    //this.transitionName = "prev";
    this.$router.push({ path: this.pages[previousPageIndex] });
  }
}
